<template>
  <div
    class="bg-gradient-to-br from-spicy-mustard-100 to-mocha-mousse-50 rounded-lg shadow-md p-6 w-full mx-auto hover:shadow-lg transition-shadow duration-300"
  >
    <div class="flex justify-between items-start">
      <h2 class="text-xl font-bold text-periwinkle-500 truncate" :title="title">
        <RouterLink :to="`/show/${id}`" class="hover:underline">
          {{ title }}
        </RouterLink>
      </h2>
      <div class="flex items-center space-x-3">
        <p class="text-gray-600 text-sm">{{ publicationDate }}</p>
        <a
          v-if="doi"
          :href="`https://doi.org/${doi}`"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img :src="doi_svg" alt="DOI" class="h-5 w-5 max-h-5 max-w-5" />
        </a>
      </div>
    </div>

    <div class="mt-4">
      <p class="text-gray-600 text-sm mb-3 line-clamp-3">{{ description }}</p>

      <!-- <div class="flex items-center text-sm text-gray-500">
        <span class="font-medium">By:</span>
        <span class="ml-2">{{ authorName }} {{ authorLastname }}</span>
        <a
          v-if="authorORCID"
          :href="`https://orcid.org/${authorORCID}`"
          target="_blank"
          rel="noopener noreferrer"
          class="ml-1"
        >
          <span class="text-blue-500 hover:underline">ORCID</span>
        </a>
      </div> -->
    </div>
  </div>
</template>

<script setup>
import { defineProps, onMounted, ref } from "vue";
const doi_svg = ref(null);

onMounted(() => {
  const base = import.meta?.env?.BASE_URL || process.env.BASE_URL || "/";
  doi_svg.value = `${base}svg/doi.svg`;
});

const props = defineProps({
  id: {
    type: Number,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  authorName: {
    type: String,
    required: true,
  },
  authorLastname: {
    type: String,
    required: true,
  },
  authorORCID: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    required: true,
  },
  doi: {
    type: String,
    required: true,
  },
  publicationDate: {
    type: String,
    required: false,
  },
});
</script>
